export default __webpack_public_path__ + "static/media/aws_elasticache_for_redis.07560586.png";